import Debug from 'debug'

const debug = Debug('change-favicon')

// updates the favicon in the DOM
export function changeFavicon(uri: string) {
  debug('changing favicon to ', uri);
  $('link[rel="icon"]').attr('href', uri);
}
